import { createApp } from 'vue';
import { createHead } from '@unhead/vue/client';
import { setupVeeValidate } from './plugins/vee-validate';
import i18n from '../i18n';
import App from './App.vue';

const app = createApp(App);

const head = createHead();

app.use(head);
app.use(i18n);
setupVeeValidate(i18n);
app.mount('#vue-best-fare');
